var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',_vm._b({class:_vm.cssClass,attrs:{"href":_vm.href,"aria-label":_vm.ariaLabel},on:{"click":function($event){return _vm.onClick($event)}}},'a',_vm.$attrs,false),[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }